export default "__VITE_ASSET__5a3565ee__"